import { records as userRecords } from '@saucelabs/sl-module-user';

import constants from './constants';
import { DeviceDescriptor } from '../realDeviceSelection/records';
import { GroupedDevices } from '../sessionInfo/types';

const isActiveFreeUser = (user: userRecords.UserRecord): boolean => (
  user?.isFreeTrial() || user?.isFreemiumCapable()
);

const sanitizeTestNameInput = (testName = ''): string => {
  // using spread operator to treat emoji as individual char
  const characters = [...testName].slice(0, constants.TEST_NAME_MAX_CHAR_LENGTH);
  return characters
    .filter((char) => new Blob([char]).size <= constants.TEST_NAME_CHAR_BYTE_MAX_LENGTH)
    .join('');
};

const selectAvailableIos17devices = (
  groupedDevices : GroupedDevices,
  availableDeviceIds:string[],
) : DeviceDescriptor[] => Object.values(groupedDevices)
  .reduce(
    (acc, selectedDevices) => {
      const matchingDevice = selectedDevices.find(
        (device) => availableDeviceIds.includes(device.descriptorId));

      if (matchingDevice) {
        acc.push(matchingDevice);
      } else {
        acc.push(selectedDevices[0]);
      }

      return acc;
    },
    [],
  );

export default {
  isActiveFreeUser,
  sanitizeTestNameInput,
  selectAvailableIos17devices,
};
